export default "__VITE_ASSET__KT4OEC58__"